import { tw } from '~/utils/tw-merge'

/**
 * A spinner that holds its place in the DOM while idle.
 *
 * Mounting a spinner conditionally makes React insert it before whatever sibling follows — in a
 * button, that is usually a bare label text node. If anything outside React has since replaced
 * that text node (mobile browsers translating the page do exactly this), `insertBefore` throws
 * DOMException 8 mid-commit, and customer-web's only error boundary is the root one, so the whole
 * page is replaced by "Something went wrong". Staying mounted keeps every state change to a class
 * swap, so React never has to place a node next to the label at all. #25603
 */
export function PendingSpinner({ isPending, className }: { isPending: boolean; className?: string }) {
  return <CircularProgress className={tw('size-5', className, !isPending && 'hidden')} />
}

function CircularProgress({ className }: { className?: string }) {
  return (
    <svg
      className={tw('animate-spin text-white', className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  )
}
